import App from 'trends-block/app';

App.init();
